export default __webpack_public_path__ + "static/triangles-62f92868090677d111b46b384c52d15b.jpg";